




































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import type { ExternalUser } from '@/models/externalUser';
import { externalUserWebservice } from '@/webservices/externalUser';
import type { Project } from '@/models/project';
import UpdateExternalUser from './UpdateExternalUser.vue';
import AddExternalUser from '@/components/projects/external-users/AddExternalUser.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'ManageExternalUsers',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        AddExternalUser,
        UpdateExternalUser,
    },
})
export default class ManageExternalUsers extends Vue {
    private isModalActive: boolean = false;
    private isLoaded: boolean = false;
    private dataUpdated: boolean = false;
    private errors: string[] = [];
    private deletedExternalUsers: ExternalUser[] = [];

    private isLoading: boolean = true;

    private tableSettings = {
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
        isNarrowed: true,
        isBordered: false,
        defaultSortDirection: 'desc',
    };

    @Prop() private project: Project;
    private externalUsers: ExternalUser[] = [] as ExternalUser[];

    private mounted() {
        this.load();
    }

    private reload() {
        this.dataUpdated = true;
        this.load();
    }

    private openModal() {
        this.isModalActive = true;
        this.load();
    }

    private closeModal() {
        this.isModalActive = false;
        this.deletedExternalUsers = [];
        if (this.dataUpdated) {
            this.$emit('reload');
        }
    }

    private load() {
        this.isLoading = true;
        externalUserWebservice
            .getAll(this.project.id)
            .then((res) => {
                this.externalUsers = res.data;
                this.isLoaded = true;
                this.isLoading = false;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    private deleteUser(deletedUser: ExternalUser) {
        this.deletedExternalUsers.push(deletedUser);
        this.externalUsers = this.externalUsers.filter((user) => user.id !== deletedUser.id);
    }

    private save() {
        if (this.deletedExternalUsers.length === 0) {
            this.closeModal();
        } else {
            externalUserWebservice
                .delete(this.deletedExternalUsers, this.project.id)
                .then((res) => {
                    this.$emit('deleted', this.deletedExternalUsers);
                    this.closeModal();
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }
}
